/* eslint import/no-cycle: 0 */
import { events } from 'client/GrowthEngineering/util/GrowthConstants';
import { useSignupStore } from 'client/signup/stores/useSignupStore';
import dreamdataRouter from 'client/GrowthEngineering/Dreamdata/dreamdataRouter';

/**
 * Trigger an event through Segment.
 * @param {String} event - The name of the event to be triggered
 * @param {Object} props - Properties to send along with the event
 */
const triggerEvent = (event, props = {}) => {
  if (!window || !window.analytics) return;

  // second try/catch for safety
  try {
    let isMobile = false;

    try {
      const signupStore = useSignupStore();
      isMobile = signupStore.isMobile;
    } catch (err) {
      // don't do anything, just catch the error so we can move on without breaking
    }

    const userDevice = {
      isMobile,
      screenSize: window.screen.width,
    };

    const eventProps = {
      ...props,
      userDevice,
    };

    // Fire tracking event
    window.analytics.track(event, eventProps);

    // Dreamdata: conversion event only (Signup Submitted).
    if (event === events.signupSubmitted) {
      dreamdataRouter.track(event, eventProps);
    }
  } catch (e) {
    // don't do anything, just catch the error so we can move on without breaking
  }
};

/**
 * Trigger Signup events
 */

const triggerAccountCreated = (payload = {}) => {
  triggerEvent(events.accountCreated, payload);
};

const triggerAccountVerified = (payload = {}) => {
  triggerEvent(events.accountVerified, payload);
};

const triggerSignupSubmitted = (payload = {}) => {
  triggerEvent(events.signupSubmitted, payload);
};

/**
 * Detects if the user is on a mobile device and updates the signup store with the mobile status.
 */
const getMobileDeviceInfo = () => {
  const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  try {
    const signupStore = useSignupStore();
    signupStore.updateIsMobile(isMobile);
  } catch (err) {
    // don't do anything, just catch the error so we can move on without breaking
  }
};

export default {
  getMobileDeviceInfo,
  triggerAccountCreated,
  triggerAccountVerified,
  triggerEvent,
  triggerSignupSubmitted,

  initialize() {
    try {
      if (window.analytics) {
        getMobileDeviceInfo();
      }
    } catch (e) {
      // don't do anything, just catch the error so we can move on without breaking
    }
  },
};
